import yup, {
    integerPositiveValidator,
    integerNegativeAllowedValidator,
    imageValidator,
    arrayValidator,
    cardNameValidator,
    ckEditorValidator,
    booleanValidator,
} from '~/utils/validators.yup';
import { MAX_DESCRIPTION } from '~/config/constants';

import { statusDetailRule } from '../components/form-sections/StatusDetail/statusDetailRule';
import { cardTransformedDetailRule } from '../components/form-sections/CardTransformedDetail/cardTransformedDetailRule';
import { dvComparedDetailRule } from '../components/form-sections/DvComparedDetail/dvComparedDetailRule';
import { typeDetailRule } from '../components/form-sections/TypeDetail/typeDetailRule';
import { rewardPenaltyDetailRule } from '../components/form-sections/RewardPenaltyDetail/rewardPenaltyDetailRule';
import { conditionCheckDetailRule } from '../components/form-sections/ConditionCheckDetail/conditionCheckDetailRule';
import { conditionSuccessFailureDetailRule } from '../components/form-sections/ConditionSuccessFailureDetail/conditionSuccessFailureDetailRule';
import { conditionAfterDetailRule } from '../components/form-sections/ConditionAfterDetail/conditionAfterDetailRule';
import { promptDetailRule } from '../components/form-sections/PromptDetail/promptDetailRule';

export const schema = (nullable = false) =>
    yup.object({
        name: cardNameValidator(),
        description: ckEditorValidator(MAX_DESCRIPTION),
        cardArt: imageValidator(nullable),
        crop: imageValidator(nullable),
        template: yup.object().shape({
            cardBack: imageValidator(true),
            cardFrame: imageValidator(true),
        }),
        keywords: arrayValidator,
        basicDetail: yup.object().shape({
            startEffects: yup
                .array()
                .of(
                    yup.object().shape({
                        activeTiming: yup.string().nullable(), // these constraints take precedence
                        effects: yup.array(), // these constraints take precedence
                    }),
                )
                .required(),
            modifiedDv1Value: integerNegativeAllowedValidator,
            modifiedDv2Value: integerNegativeAllowedValidator,
            attackModifiedValue: integerNegativeAllowedValidator,
            defenseModifiedValue: integerNegativeAllowedValidator,
            fixedDvValue: integerPositiveValidator,
            maxDvValue: integerPositiveValidator,
            damageValue: integerPositiveValidator,
            healedValue: integerPositiveValidator,
            hpValue: integerPositiveValidator,
            blockModifiedValue: integerNegativeAllowedValidator,
            duelEffects: arrayValidator,
            numberOfCardsToMoveValue: integerPositiveValidator,
            hitValue: integerPositiveValidator,
            penaltyDvValue: integerPositiveValidator,
            pointToStealValue: integerPositiveValidator,
            powerToRefresh: yup.mixed(),
            persistentDvValue: integerPositiveValidator,
            persistentStrikeValue: integerPositiveValidator,
            persistentBlockValue: integerPositiveValidator,
        }),
        ...statusDetailRule,
        ...cardTransformedDetailRule,
        ...dvComparedDetailRule,
        ...typeDetailRule,
        ...rewardPenaltyDetailRule,
        ...conditionCheckDetailRule,
        ...conditionSuccessFailureDetailRule,
        ...conditionAfterDetailRule,
        ...promptDetailRule,
        miscellaneousDetail: yup.object().shape({
            isDamagePlayer: booleanValidator,
            isDamageAggressor: booleanValidator,
            isDamageWinner: booleanValidator,
            isEvenCondition: booleanValidator,
        }),
    });
